export default "/images/lock.svg?5ec12f112e2425147233b35eb64a4bfe";